import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth-slice";
import { dashboardReducer } from "./dashboard-slice";
import { devotionReducer } from "./devotion-slice";
import { donationReducer } from "./donation-slice";
import { eventsReducer } from "./events-slice";
import { hymnsReducer } from "./hymn-slice";
import { resourceReducer } from "./resources-slice";
import { resourceTypeReducer } from "./resourceType-slice";
import { subscriptionReducer } from "./subscription-slice";
import { utilitiesReducer } from "./utilities-slice";

export const store = configureStore({
   reducer: {
      utilities: utilitiesReducer,
      auth: authReducer,
      hymns: hymnsReducer,
      devotions: devotionReducer,
      events: eventsReducer,
      susbcriptions: subscriptionReducer,
      donations: donationReducer,
      dashboard: dashboardReducer,
      resources: resourceReducer,
      resourceType: resourceTypeReducer,
   },
});
